import { useOutletContext } from 'react-router-dom';

/**
 * True when rendered inside the Technology tab shell (via prop or outlet context).
 */
export function useTechnologyEmbedded(propEmbedded = false) {
  const outlet = useOutletContext();
  return Boolean(propEmbedded || outlet?.embedded);
}
